module.exports = {
      id: "register_start-usage",
      viewBox: "0 0 67.6 59.9",
      url: "/typo3conf/ext/samson_druck_sitepackage/Resources/Public/Theme/img/" + "sprite.svg#register_start",
      toString: function () {
        return this.url;
      }
    }